import SpriteSymbol from "../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkcircleo",
  "use": "checkcircleo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"checkcircleo\"><path d=\"M11.266 4.781L6.157 9.906 4.813 7.578q-.109-.203-.336-.266t-.43.055-.266.336.063.422l1.703 2.984q.156.281.484.281.156 0 .281-.078.078-.047.125-.094l.016-.016 5.609-5.625q.172-.172.172-.406t-.164-.398-.398-.164-.406.172zM8 0Q5.828 0 3.984 1.07T1.07 3.984 0 8t1.07 4.016 2.914 2.914T8 16t4.016-1.07 2.914-2.914T16 8t-1.07-4.016-2.914-2.914T8 0zm4.859 12.859q-.953.953-2.188 1.469-1.266.547-2.672.547t-2.672-.531q-1.234-.531-2.188-1.484T1.67 10.672Q1.123 9.406 1.123 8t.531-2.672q.531-1.234 1.484-2.188t2.188-1.469q1.266-.547 2.672-.547t2.672.531q1.234.531 2.188 1.484t1.469 2.188q.547 1.266.547 2.672t-.531 2.672q-.531 1.234-1.484 2.188z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/checkcircleo.svg
// module id = 183
// module chunks = 0